import React from "react";

export function Spinner({ label }) {
  return (
    <span className="muted">
      <span className="spinner" /> {label || "Working…"}
    </span>
  );
}

export function ErrorBanner({ error, onDismiss }) {
  if (!error) return null;
  return (
    <div className="banner error">
      <strong>Something went wrong.</strong> {String(error.message || error)}
      {onDismiss && (
        <>
          {" "}
          <button className="link" onClick={onDismiss}>
            dismiss
          </button>
        </>
      )}
    </div>
  );
}

export function Pill({ kind = "neutral", children }) {
  return <span className={`pill ${kind}`}>{children}</span>;
}

/** A labelled key/value pair, for the run metadata blocks. */
export function Detail({ label, children }) {
  return (
    <div>
      <div className="muted" style={{ fontSize: "0.78rem" }}>
        {label}
      </div>
      <div>{children ?? "—"}</div>
    </div>
  );
}

export function DetailRow({ children }) {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
        gap: "0.75rem",
      }}
    >
      {children}
    </div>
  );
}
